@for (flight of flightDestinationArray; track flight; let i = $index; let last = $last) {
  <app-multi-city-destination-input
    [flight]="flight"
    [flightIndex]="i"
    [flightLocations]="flightLocations"
    [flightLocations2]="flightLocations2"
    [formatter_rail_air]="formatter_rail_air"
    [minDate]="i === 0 ? minDate : minNextDate"
    class="five-eighths-container flight-search__destination-container search-form-row-holder"
    (selectedInput)="updateTemp($event)"
    (flightRemove)="removeFlight($event)"
    [outTimeCriteria]="outTimeCriteria"
    [criteria]="criteria"
    [isLast]="i === flightDestinationArray.length - 1"
  ></app-multi-city-destination-input>
}
<div class="flex-row-container add-fligth-wrapper">
  <button
    appButton="small"
    id="multicity-button-add-another-flight"
    [disabled]="flightDestinationArray.length >= maxSectors"
    i18n="@@AddAnotherFlight"
    (click)="addFlight()"
  >
    Add another flight
  </button>
</div>
